import styled from 'styled-components';
import {AccentColorOptions} from 'epic-ue-theme';

export const SelectDropdownWrapper = styled.div<{accentColor: AccentColorOptions}>`
    && {
        text-align: center;
        .underlined-select > div {
            padding-right: 32px;
            padding-bottom: 16px;
            ${(p) => p.theme.breakpoints.down('lg')} {
                padding-bottom: 12px;
            }
            ${(p) => p.theme.breakpoints.down('sm')} {
                padding-bottom: 8px;
            }
        }
        .select-arrow {
            &:before,
            &:after {
                width: 2px;
            }
            padding-bottom: 16px;
            ${(p) => p.theme.breakpoints.down('lg')} {
                padding-bottom: 12px;
            }
            ${(p) => p.theme.breakpoints.down('sm')} {
                padding-bottom: 8px;
            }
        }
    }
`;
